import { HTTPStatusCode } from "@libs/api/types";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const BrokersApi = {
  getBroker: async () => {
    const res = await tsRestClient().brokers.getBroker();

    // `null` body means no broker for the patient's state — an expected outcome;
    // the screen falls back to the generic subtitle.
    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      error: res.body,
      message: "Unexpected response in BrokersApi.getBroker",
      shouldThrowError: true,
    });
  },
};
